import { createContext, useContext } from "react";

import { createStore, useStore } from "zustand";

import { CellsRange } from "@/types/spreadsheet";

type MainState = {
  selection: {
    current: CellsRange | null;
    set: (
      address: string,
      id: string,
      tableId: string,
      anchorAddress?: string,
    ) => void;
  };
};

export const createMainStore = () =>
  createStore<MainState>()((set) => ({
    selection: {
      current: null,
      set: (address, id, tableId, anchorAddress) => {
        const [sheetName, cellAddress] = address.split("!");
        set((state) => ({
          selection: {
            ...state.selection,
            current: {
              address: cellAddress,
              anchorAddress,
              sheet: { id, name: sheetName, tableId },
            },
          },
        }));
      },
    },
  }));

export const MainStoreContext = createContext<ReturnType<
  typeof createMainStore
> | null>(null);

export const useMainStore = <T>(selector: (state: MainState) => T): T => {
  const store = useContext(MainStoreContext);

  if (!store) {
    throw new Error("Missing MainStoreProvider in the component tree");
  }

  return useStore(store, selector);
};
